/*!
 * KoliBri - The accessible HTML-Standard
 */
import { J as watchJsonArrayString, k as a11yHint } from './common-D-vggmh2.js';

const validateSuggestions = (component, value) => {
    watchJsonArrayString(component, '_suggestions', (item) => typeof item === 'string' || typeof item === 'number', value, undefined, {
        hooks: {
            afterPatch: (value) => {
                if (Array.isArray(value) && value.length) {
                    a11yHint('Property suggestions: Options have accessibility issues in how browsers implemented them and should not be used for now.');
                }
            },
        },
    });
};

export { validateSuggestions as v };
//# sourceMappingURL=suggestions-CKylTAKv.js.map

//# sourceMappingURL=suggestions-CKylTAKv.js.map